module.exports = __webpack_public_path__ + "static/media/decrease.0a89abf6.png";